import React, { Fragment, useState } from "react";
import { MdCloudUpload, MdCreate } from "react-icons/md";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import axios from "axios";
import { config_url } from "../../config";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  height: "50vh",
  border: "2px solid #000",
  borderRadius: "12px",
  boxShadow: 24,
  overflowY: "scroll",
  p: 4,
};

function UpdImageJob({ closeModal, rowJob }) {
  const [imageFile, setImageFile] = useState(null);
  const [fileName, setFileName] = useState("No selected file");

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!imageFile) {
      toast.error("Please select an image!", { position: "top-right" });
      return;
    }

    const formData = new FormData();
    formData.append("image_vacance", imageFile);

    try {
      const response = await axios.put(
        `${config_url}/api/affected-image-job/${rowJob.id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200) {
        toast.success("Image updated successfully!", { position: "top-right" });
        closeModal();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update image!", { position: "top-right" });
    }
  };

  return (
    <Fragment>
      <Modal open={true} onClose={closeModal}>
        <Box sx={style}>
          <Typography variant="h5" gutterBottom>
            Update Job Image
          </Typography>
          <Divider />
          <div className="m-10">
            <div
              className="form"
              onClick={() => document.querySelector(".input-field").click()}
            >
              <input
                type="file"
                className="input-field"
                hidden
                onChange={({ target: { files } }) => {
                  if (files[0]) {
                    setImageFile(files[0]);
                    setFileName(files[0].name);
                  }
                }}
              />
              {imageFile ? (
                <img
                  src={URL.createObjectURL(imageFile)}
                  alt={fileName}
                  className="w-[150px] h-[150px] rounded-full border-2 border-gray-400"
                />
              ) : (
                <>
                  <MdCloudUpload size={60} color="#1475cf" />
                  <p>Upload Image</p>
                </>
              )}
            </div>
          </div>
          <Divider />
          <div className="mt-4 flex justify-end">
            <Button
              variant="contained"
              color="primary"
              startIcon={<MdCreate />}
              onClick={handleUpload}
            >
              Save
            </Button>
          </div>
        </Box>
      </Modal>
    </Fragment>
  );
}

export default UpdImageJob;
